var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometerVeryLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 40,
    viewBox: "0 0 21 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1666 22.5463V6.66664C17.1666 2.98477 14.1819 0 10.5 0C6.81813 0 3.83336 2.98477 3.83336 6.66664V22.5463C1.7875 24.3773 0.5 27.0384 0.5 30C0.5 35.5229 4.97719 40 10.5 40C16.0228 40 20.5 35.5229 20.5 30C20.5 27.0384 19.2125 24.3773 17.1666 22.5463ZM10.5 36.6666C6.81813 36.6666 3.83336 33.6819 3.83336 30C3.83336 28.0752 4.64906 26.2897 6.05641 25.0301L7.16672 24.0363V6.66664C7.16672 4.8257 8.65914 3.33328 10.5001 3.33328C12.341 3.33328 13.8334 4.82562 13.8334 6.66664V24.0363L14.9438 25.0301C16.3511 26.2897 17.1668 28.0752 17.1668 30C17.1666 33.6819 14.1819 36.6666 10.5 36.6666Z",
    fill: "white",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60001 29C5.53443 29.3231 5.5 29.6575 5.5 30C5.5 32.7614 7.73858 35 10.5 35C13.2614 35 15.5 32.7614 15.5 30C15.5 29.6575 15.4656 29.3231 15.4 29H5.60001Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerVeryLow);
export default __webpack_public_path__ + "static/media/thermometer_very_low.6a61c85146cae72a3c252c6f620f9067.svg";
export { ForwardRef as ReactComponent };